/**
 * FacetWP pagination
 */
var component_facetwp_pagination = function (args) {
  // setup args
  var pagination = args.pagination;
  var teaser_container = document.querySelector(".teaser-container");

  // get teaser container on product category pages
  // Commented out to prevent scrolling on load more
  // if (document.body.classList.contains('tax-product_cat')) {
  //   teaser_container = document.querySelector('.product-list-tabs__products');
  // }

  if (pagination) {
    // FacetWP refresh event handler
    document.addEventListener("facetwp-refresh", function () {
      if (FWP.soft_refresh === true) {
        FWP.enable_scroll = true;
      } else {
        FWP.enable_scroll = false;
      }
    });

    // FacetWP loaded event handler
    document.addEventListener("facetwp-loaded", function () {
      if (FWP.enable_scroll === true && teaser_container) {
        var targetPosition =
          teaser_container.getBoundingClientRect().top +
          window.pageYOffset -
          300;

        window.scrollTo({ top: targetPosition, behavior: "smooth" });
      }
    });
  }

  // make the call chainable
  return this;
};
